import { FC, useEffect, useState } from "react";
import JobForm, { JobFormValues } from "../job-form";
import {Link} from "react-router";

interface Props {
    jobId?: number;
    jobName?: string;
    onSubmit: (_form: JobFormValues) => void;
}

const JobField:FC<Props> = ({ jobId, jobName, onSubmit }) => {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const formId = "assignJobForm";

    const showForm = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsFormVisible(true);
    };

    useEffect(() => {
        setIsFormVisible(false);
    }, [jobId]);

    return (
        <div className="info-field mb-4">
            <div className="d-flex justify-content-between justify-content-center">
                <h5 className="field-title d-flex justify-content-between align-items-center">
                    Linked Job
                </h5>
                {jobId && !isFormVisible && (
                    <a
                        role="button"
                        aria-expanded={isFormVisible}
                        aria-controls={formId}
                        className="text-primary"
                        onClick={showForm}
                    >Edit</a>
                )}
            </div>

            {isFormVisible
                ? (
                    <JobForm
                        id={formId}
                        value={jobId}
                        onSubmit={onSubmit}
                    />
                )
                : (
                    <>

                        {jobId
                            ? (
                                <div className="field-value">
                                    <Link
                                        to={`/jobs/${jobId}`}
                                    >{jobName}</Link>
                                </div>
                            )
                            : (
                                <a
                                    role="button"
                                    aria-expanded={isFormVisible}
                                    aria-controls={formId}
                                    className="text-primary"
                                    onClick={showForm}
                                >
                                    Link Job
                                </a>
                            )
                        }
                    </>
                )
            }
        </div>
    );
};

export default JobField;
